import { createFileRoute } from '@tanstack/react-router';

import MediaPlanDetail from '@/features/mediaPlan/pages/MediaPlanDetail';
import {
  mediaPlanDetailParamsSchema,
  mediaPlanDetailSearchParamsSchema,
} from '@/features/mediaPlan/schemas';

export const Route = createFileRoute('/_app/media-plans_/$id')({
  params: {
    parse: (params) => mediaPlanDetailParamsSchema.parse(params),
    stringify: ({ id }) => ({ id: String(id) }),
  },
  validateSearch: mediaPlanDetailSearchParamsSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <MediaPlanDetail id={id} />;
}
